import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantBankService } from '../../services/wealthlane-finance-integration-services';

const useGetBankRoutingType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const bankRoutingType = useQuery(
    ['getBankRoutingType'],
    async () => {
      return await handleRequest(
        ParticipantBankService.getApiFinanceIntegrationApiAppParticipantBankRoutingType()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: String(item.id) ?? '',
          };
        });
      },
    }
  );

  return bankRoutingType;
};

export default useGetBankRoutingType;
